import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {CategorySearchModel} from "../category-search.model";
import {CategoryEntityModel} from "../category-entity.model";
import {SearchActionEvent} from "../../../framework/entity/search/search-page/search-action-event";
import {PageParameterService} from "../../../framework/entity/page-parameter.service";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {CategoryMoveAction, CategoryMoveService} from "../category-move.service";
import {FUIAlertAction} from "@fedeltapointofsale/ui";
import {FUIAlertActions, FUIAlertService, FUISpinnersService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-category-search-page",
    templateUrl: "./category-search-page.component.html",
    styleUrls: ["./category-search-page.component.scss"],
    providers: [provideSearchModel(CategorySearchModel),
        provideEntityModel(CategoryEntityModel),
        PageParameterService,
        CategoryMoveService]
})
export class CategorySearchPageComponent extends AbstractSearchPage {
    sourceCategory: any;

    constructor(public searchModel: CategorySearchModel,
                public entityModel: CategoryEntityModel,
                private categoryMoveService: CategoryMoveService,
                private alertService: FUIAlertService,
                private spinnersService: FUISpinnersService) {
        super();
    }

    toggleCollapseCategory(category: any): void {
        this.searchModel.toggleCollapseCategory(category);
    }

    fireEditEvent(dataItem: any): void {
        this.searchPageComponent.handleActionEvent(new SearchActionEvent(SearchActionEvent.ACTION_EDIT, dataItem));
    }

    addRecord(dataItem: any): void {
        if (this.entityModel.hasCategoryMovePrivilege) {
            this.searchPageComponent.handleActionEvent(new SearchActionEvent(SearchActionEvent.ACTION_ADD_FROM_RECORD, dataItem));
        }
    }

    allowDrop(ev: DragEvent, targetCategory: any) {
        if (!this.entityModel.hasCategoryMovePrivilege || this.sourceCategory.categoryId !== targetCategory.categoryId) {
            ev.preventDefault();
            ev.stopPropagation();
        }
    }

    drag(ev: DragEvent, category: any): void {
        if (this.entityModel.hasCategoryMovePrivilege) {
            this.sourceCategory = category;
        }
    }

    async drop(ev: DragEvent, targetCategory: any): Promise<void> {
        ev.preventDefault();

        if (this.entityModel.hasCategoryMovePrivilege) {
            const action: FUIAlertAction = await this.alertService.showConfirmationOkCancel("wbo.category.edit.prompt.moveCategory.heading",
                "wbo.category.edit.prompt.moveCategory.message", {
                    source: this.sourceCategory.name,
                    target: targetCategory.name
                }).toPromise();
            if (action === FUIAlertActions.OK_ACTION) {
                this.spinnersService.open();
                try {
                    await this.categoryMoveService.performAction(new CategoryMoveAction(parseInt(this.sourceCategory.categoryId), targetCategory.categoryId));
                    this.searchPageComponent.refresh();
                } finally {
                    this.spinnersService.close();
                }
            }
        }
    }
}
